import { AlertCircle } from "lucide-react";
import { useSearchParams } from "react-router";
import SigneringResultCard, {
  SigneringResultActionLink,
} from "@cle/components/signering/SigneringResultCard";
import { CUSTOM_MSG } from "@/constants/messages";
import {
  getSigneringMessage,
  getSigneringSearchParams,
} from "@cle/utils/signeringSearchParams";
import { EFT_BASE_PATH } from "@cle/constants/routes";

const SigneringFailureView = () => {
  const [searchParams] = useSearchParams();
  const { messageId } = getSigneringSearchParams(searchParams);
  const message = getSigneringMessage(messageId);

  return (
    <div className="cle-signering-result-page">
      <SigneringResultCard
        variant="failure"
        icon={<AlertCircle size={36} strokeWidth={1.75} aria-hidden />}
        title={CUSTOM_MSG.mitIdSigneringFailure}
        messageHtml={message || CUSTOM_MSG.mitIdLoginFailureText}
        actions={
          <>
            <SigneringResultActionLink
              id="cle-signering-failure-retry"
              to="/login"
            >
              Prøv igen
            </SigneringResultActionLink>
            <SigneringResultActionLink
              id="cle-signering-failure-home"
              to={EFT_BASE_PATH}
              variant="secondary"
            >
              Gå til efteruddannelse
            </SigneringResultActionLink>
          </>
        }
      />
    </div>
  );
};

export default SigneringFailureView;
